import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ArrowLeftIcon, ArrowRightIcon, AwardIcon, CheckCircle2Icon, CalendarIcon, UtensilsIcon, GraduationCapIcon } from 'lucide-react';
import { ScrollReveal } from '../components/ScrollReveal';
export function IntensivCurriculumPage() {
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-597">
      <Navbar data-id="element-598" />

      <main className="flex-grow pt-24 pb-20" data-id="element-599">
        {/* Hero Section */}
        <div className="relative h-[60vh] min-h-[500px] w-full mb-16" data-id="element-600">
          <div className="absolute inset-0" data-id="element-601">
            <img src="https://cdn.rawproductionsgmbh.de/2n/home/curriculum.jpeg" alt="2N Intensiv Curriculum" className="w-full h-full object-cover" data-id="element-602" />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/60 to-transparent" data-id="element-603"></div>
          </div>

          <div className="absolute inset-0 flex items-end pb-16" data-id="element-604">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full" data-id="element-605">
              <Link to="/#kurse" className="inline-flex items-center text-white/80 hover:text-white font-semibold mb-8 transition-colors backdrop-blur-sm bg-white/10 px-4 py-2 rounded-full border border-white/20" data-id="element-606">
                <ArrowLeftIcon className="w-4 h-4 mr-2" data-id="element-607" /> Zurück zur Übersicht
              </Link>

              <ScrollReveal variant="up" data-id="element-608">
                <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/20 text-amber-400 text-sm font-extrabold uppercase tracking-wider mb-6 border border-amber-500/30 backdrop-blur-md" data-id="element-609">
                  <AwardIcon className="h-5 w-5" data-id="element-610" />
                  78 Fortbildungspunkte
                </div>
                <h1 className="text-3xl md:text-6xl lg:text-7xl font-extrabold text-white mb-4 tracking-tight" data-id="element-611">
                  2N Intensiv Curriculum
                </h1>
                <p className="text-lg md:text-2xl text-[#59d0d4] font-medium max-w-3xl" data-id="element-612">
                  Ästhetik, Funktion & Praxisführung
                </p>
              </ScrollReveal>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-613">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12" data-id="element-614">
            {/* Main Content Column */}
            <div className="lg:col-span-8 space-y-12" data-id="element-615">
              {/* Intro */}
              <ScrollReveal variant="up" data-id="element-616">
                <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-slate-100" data-id="element-617">
                  <h2 className="text-2xl font-extrabold text-slate-700 mb-6" data-id="element-618">
                    Wissenschaft und kollegiales Netzwerk vereint
                  </h2>
                  <div className="space-y-6 text-base sm:text-lg text-slate-600 font-medium leading-relaxed" data-id="element-619">
                    <p data-id="element-620">
                      Als Fortbildungsinstitut für Zahnärzte und Praxisteams ist
                      es uns ein besonderes Anliegen, über die fachliche
                      Komponente hinaus, in entspannter Atmosphäre zu
                      netzwerken, sowie Erfahrungen und Know-How gegenseitig
                      auszutauschen. Hierfür möchten wir im Rahmen unserer
                      Fortbildungen einen Raum schaffen, der Wissenschaft und
                      kollegiales Netzwerk vereint.
                    </p>
                    <p data-id="element-621">
                      Unser 2N Intensiv-Curriculum Ästhetik und Funktion bildet
                      Sie zu den Themen Weiße Ästhetik, Rote Ästhetik, Funktion
                      sowie Praxisführung fort. Zusätzlich dazu bietet es Ihnen
                      die Möglichkeit sich unter Kollegen auszutauschen und
                      wertvolle Impulse für Ihren Praxisalltag mit nach Hause zu
                      nehmen.
                    </p>
                    <p data-id="element-622">
                      Kompetent und praxisnah stellen wir Ihnen Methoden vor,
                      die Sie direkt im Anschluss in Ihrer Praxis anwenden
                      können. Dabei vermitteln wir viele wichtige Tipps und
                      praktische Ideen, die kurzweilig anhand zahlreicher
                      Patientenfälle, Hands-on Elementen und Live-Behandlungen
                      demonstriert werden.
                    </p>
                  </div>
                </div>
              </ScrollReveal>

              {/* Ablauf & Bonus */}
              <ScrollReveal variant="up" data-id="element-623">
                <div className="bg-gradient-to-br from-[#3b7780] to-[#2d5f66] rounded-3xl p-8 md:p-12 shadow-xl text-white relative overflow-hidden" data-id="element-624">
                  <div className="absolute -top-20 -right-20 w-64 h-64 bg-[#59d0d4] rounded-full mix-blend-screen filter blur-[60px] opacity-30" data-id="element-625"></div>

                  <div className="relative z-10" data-id="element-626">
                    <div className="flex items-center gap-4 mb-6" data-id="element-627">
                      <div className="bg-white/20 p-3 rounded-2xl backdrop-blur-sm" data-id="element-628">
                        <GraduationCapIcon className="w-8 h-8 text-[#59d0d4]" data-id="element-629" />
                      </div>
                      <h2 className="text-2xl md:text-3xl font-extrabold" data-id="element-630">
                        Ablauf des Curriculums
                      </h2>
                    </div>

                    <p className="text-lg text-slate-200 font-medium leading-relaxed mb-8" data-id="element-631">
                      Bei Buchung unseres Intensiv-Curriculums durchlaufen Sie
                      unsere Kursreihe mit den Themen Weiße Ästhetik, Rote
                      Ästhetik, Funktion und erfolgreiche Praxisführung.
                    </p>

                    <div className="bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm" data-id="element-632">
                      <h3 className="text-[#59d0d4] font-extrabold text-xl mb-2" data-id="element-633">
                        🎁 Exklusiver Bonus
                      </h3>
                      <p className="text-white font-medium mb-4" data-id="element-634">
                        Zum Abschluss der gesamten Kursserie profitieren Sie von
                        einem zusätzlichen kostenfreien Kurswochenende im Laufe
                        des Jahres!
                      </p>
                      <p className="text-sm text-slate-300" data-id="element-635">
                        <span className="line-through mr-2" data-id="element-636">
                          Normalpreis: 1.650,-€ zzgl. MwSt.
                        </span>
                        <span className="font-bold text-white" data-id="element-637">
                          Kostenfrei bei Buchung des Intensiv Curriculums.
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ScrollReveal>

              {/* Module & Termine */}
              <ScrollReveal variant="up" data-id="element-638">
                <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-slate-100" data-id="element-639">
                  <div className="flex items-center gap-4 mb-8" data-id="element-640">
                    <div className="bg-[#59d0d4]/15 p-3 rounded-2xl" data-id="element-641">
                      <CalendarIcon className="w-8 h-8 text-[#3b7780]" data-id="element-642" />
                    </div>
                    <h2 className="text-2xl md:text-3xl font-extrabold text-slate-700" data-id="element-643">
                      Module & Termine 2026
                    </h2>
                  </div>

                  <div className="space-y-6" data-id="element-644">
                    {[{
                    title: 'Modul 1: Experte für Weiße Ästhetik',
                    date: '17./18. April 2026',
                    time: 'Freitag: 14.00-19.00 Uhr | Samstag: 09.00-16.30 Uhr'
                  }, {
                    title: 'Modul 2: Experte für Rote Ästhetik',
                    date: '03./04. Juli 2026',
                    time: 'Freitag: 14.00-19.00 Uhr | Samstag: 09.00-16.30 Uhr'
                  }, {
                    title: 'Modul 3: Experte für Funktionsdiagnostik',
                    date: '02./03. Oktober 2026',
                    time: 'Freitag: 14.00-19.00 Uhr | Samstag: 09.00-16.30 Uhr'
                  }, {
                    title: 'Modul 4: Experte für Praxiserfolg und Führung',
                    date: '04./05. Dezember 2026',
                    time: 'Freitag: 14.00-19.00 Uhr | Samstag: 09.00-16.30 Uhr'
                  }].map((modul, idx) => <div key={idx} className="flex flex-col md:flex-row md:items-center justify-between p-6 rounded-2xl bg-slate-50 border border-slate-100 hover:border-[#59d0d4]/30 transition-colors" data-id="element-645">
                        <div className="mb-4 md:mb-0" data-id="element-646">
                          <h3 className="text-lg font-extrabold text-slate-700 mb-1" data-id="element-647">
                            {modul.title}
                          </h3>
                          <p className="text-[#3b7780] font-bold" data-id="element-648">
                            {modul.date}
                          </p>
                        </div>
                        <div className="text-sm font-medium text-slate-500 bg-white px-4 py-2 rounded-lg border border-slate-200" data-id="element-649">
                          {modul.time}
                        </div>
                      </div>)}
                  </div>
                </div>
              </ScrollReveal>

              {/* Dinner & Networking */}
              <ScrollReveal variant="up" data-id="element-650">
                <div className="bg-white rounded-3xl overflow-hidden shadow-sm border border-slate-100" data-id="element-651">
                  <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-652">
                    <div className="p-8 md:p-12 flex flex-col justify-center" data-id="element-653">
                      <div className="flex items-center gap-3 mb-6" data-id="element-654">
                        <UtensilsIcon className="w-6 h-6 text-[#59d0d4]" data-id="element-655" />
                        <h2 className="text-2xl font-extrabold text-slate-700" data-id="element-656">
                          Dinner & Networking
                        </h2>
                      </div>
                      <p className="text-slate-600 font-medium leading-relaxed mb-4" data-id="element-657">
                        Am Freitagabend eines jeden Kurses gibt es ein
                        gemeinsames Dinner in der Pizzeria Travolta in Nürnberg
                        – inklusive Weinbegleitung und 3-Gang Menü.
                      </p>
                      <p className="text-slate-600 font-medium leading-relaxed" data-id="element-658">
                        Im Travolta gibt es italienische Küche von modernen
                        Antipasti über Pizza Napoletana und Pasta bis hin zu
                        ausgewählten Gerichten der Wochenkarte – mit den besten
                        Zutaten – einfach, naturbelassen, frisch und
                        authentisch. Im italo-schickem Ambiente zelebrieren wir
                        italienischen Lifestyle.
                      </p>
                    </div>
                    <div className="h-64 md:h-auto bg-slate-200" data-id="element-659">
                      <img src="https://cdn.rawproductionsgmbh.de/2n/home/header.jpg" alt="Networking Dinner" className="w-full h-full object-cover" data-id="element-660" />
                    </div>
                  </div>
                </div>
              </ScrollReveal>
            </div>

            {/* Sidebar Column */}
            <div className="lg:col-span-4 space-y-8" data-id="element-661">
              <div className="sticky top-32" data-id="element-662">
                {/* Pricing Card */}
                <ScrollReveal variant="left" data-id="element-663">
                  <div className="bg-[#1a1a1a] rounded-3xl p-8 text-white shadow-xl mb-8 relative overflow-hidden border border-slate-800" data-id="element-664">
                    <h3 className="text-xl font-extrabold mb-2 text-slate-300" data-id="element-665">
                      Ihre Investition
                    </h3>
                    <h4 className="text-2xl font-extrabold mb-6 text-white" data-id="element-666">
                      Intensiv Curriculum
                    </h4>

                    <div className="mb-8" data-id="element-667">
                      <div className="flex items-baseline gap-2 mb-2" data-id="element-668">
                        <span className="text-4xl font-extrabold text-[#59d0d4]" data-id="element-669">
                          5.490 €
                        </span>
                      </div>
                      <p className="text-sm text-slate-400 font-medium mb-4" data-id="element-670">
                        zzgl. 19% MwSt. (inklusive Verpflegung und
                        Abendprogramm)
                      </p>
                      <div className="bg-white/10 p-4 rounded-xl border border-white/5" data-id="element-671">
                        <p className="text-sm text-slate-300 font-medium flex justify-between" data-id="element-672">
                          <span data-id="element-673">GESAMT inkl. MwSt:</span>
                          <span className="font-bold text-white" data-id="element-674">
                            6.533,10 €
                          </span>
                        </p>
                      </div>
                    </div>

                    <Link to="/kontakt" className="flex items-center justify-center w-full px-6 py-4 bg-[#59d0d4] text-[#1a1a1a] hover:bg-[#4abfc3] font-extrabold rounded-xl transition-all duration-300 shadow-[0_0_20px_rgba(89,208,212,0.3)] hover:scale-105 group relative z-10 uppercase tracking-wider" data-id="element-675">
                      <span data-id="element-676">Jetzt Kursplatz sichern!</span>
                      <ArrowRightIcon className="w-5 h-5 ml-2 transform group-hover:translate-x-1 transition-transform" data-id="element-677" />
                    </Link>
                  </div>
                </ScrollReveal>

                {/* Course Contents List */}
                <ScrollReveal variant="up" delay={200} data-id="element-678">
                  <div className="bg-white rounded-3xl p-8 shadow-sm border border-slate-100" data-id="element-679">
                    <h3 className="text-xl font-extrabold text-slate-700 mb-6" data-id="element-680">
                      Aus dem Inhalt
                    </h3>
                    <ul className="space-y-4" data-id="element-681">
                      {['A-Kurs: Weiße Ästhetik', 'B-Kurs: Rote Ästhetik', 'C-Kurs: Funktion', 'D-Kurs: Die 7 Säulen des Praxiserfolges'].map((item, idx) => <li key={idx} className="flex items-center p-3 rounded-xl bg-slate-50 border border-slate-100" data-id="element-682">
                          <div className="bg-[#3b7780] text-white w-8 h-8 rounded-lg flex items-center justify-center font-bold mr-4 flex-shrink-0" data-id="element-683">
                            {item.charAt(0)}
                          </div>
                          <span className="text-slate-700 font-bold" data-id="element-684">
                            {item.split(': ')[1]}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </ScrollReveal>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-685" />
    </div>;
}